import { render, staticRenderFns } from "./RobotVip.vue?vue&type=template&id=00549441"
import script from "./RobotVip.vue?vue&type=script&lang=js"
export * from "./RobotVip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports